import Vue from "vue";
import Vuex from "vuex";
import http from "./http";
import auth from "./auth";
import cable from "./cable";
import currentUser from "./currentUser";
import currentScouting from "./currentScouting";
import currentCompany from "./currentCompany";

Vue.use(Vuex);
import VuexPersist from "vuex-persist";

const vuexPersist = new VuexPersist({
  key: "lime",
  storage: window.localStorage,
  modules: ["auth"],
});

export default new Vuex.Store({
  modules: {
    auth,
    currentUser,
    currentScouting,
    currentCompany,
    http,
    cable,
  },
  plugins: [vuexPersist.plugin],
});
